// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Sorting_tabs__oh2JG","label":"Sorting_label__3eQle","dropdown":"Sorting_dropdown__3DOP5"};